import { useMemo } from "react";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import SelectDropdownIcon from "./SelectDropdownIcon";

/** Apply the local dropdown SVG on every MUI Select in the tree. */
export default function SelectDropdownTheme({ children }) {
  const theme = useTheme();
  const next = useMemo(
    () =>
      createTheme(theme, {
        components: {
          MuiSelect: {
            defaultProps: {
              IconComponent: SelectDropdownIcon,
            },
          },
        },
      }),
    [theme]
  );
  return <ThemeProvider theme={next}>{children}</ThemeProvider>;
}
